import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import img1 from "./img/dashboardImg1.png";
import img2 from "./img/dashboardImg2.png";
import img3 from "./img/dashboardImg3.png";
import img4 from "./img/dashboardImg4.png";

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        padding: { xs: 6, md: 10 },
      }}
    >
      <Box
        sx={{
          width: { xl: "100%", lg: "100%", md: "90%", sm: "90%" },
        }}
      >
        {/* Main Heading */}
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            fontSize: isMobile ? "1.8rem" : "2.5rem",
            mb: isMobile ? 3 : 5,
            textAlign: "center",
            fontFamily: "'Roboto', sans-serif",
            mb: 6,
          }}
        >
          Manage Everything in One Single Dashboard
        </Typography>

        <Grid container spacing={4}>
          {/* Card 1 */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                height: "100%",
                minHeight: isMobile ? 550 : 650,
                borderRadius: 3,
                border: "1px solid #e0e0e0",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                cursor: "pointer",
                transition: "transform .3s, box-shadow .3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
                },
                bgcolor: "rgb(230, 240, 255)",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  // background: `url(${img1}) no-repeat center/cover`,
                  opacity: 0.4,
                  borderRadius: "inherit",
                  zIndex: -1,
                },
              }}
            >
              <CardContent sx={{ pt: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  Target better with AI Ad Campaign Manager
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Use AI to target better audiences, drive 3-5x more
                  conversions.
                </Typography>
              </CardContent>
              <Box sx={{ position: "relative", flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                <CardMedia
                  component="img"
                  image={img1}
                  alt="Dashboard Screenshot"
                  sx={{
                    width: "100%",
                    objectFit: "contain",
                    mt: 4,
                    maxHeight: isMobile ? 350 : 450,
                  }}
                />
                {/* <Stat
                  label="Impressions"
                  value="22,85,134"
                  bottom={24}
                  left={24}
                  mobile={isMobile}
                />
                <Stat
                  label="Clicks"
                  value="20,686"
                  bottom={24}
                  right={24}
                  mobile={isMobile}
                /> */}
              </Box>
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} md={7}>
            <Card
              sx={{
                height: "100%",
                minHeight: isMobile ? 600 : 750,
                borderRadius: 3,
                border: "1px solid #e0e0e0",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                cursor: "pointer",
                bgcolor: 'rgb(255, 238, 230)',
                transition: "transform .3s, box-shadow .3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  // boxShadow: '0 0 16px rgba(100,200,100,0.4)',
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  // background: `url(${img2}) no-repeat center/cover`,
                  opacity: 0.4,
                  borderRadius: "inherit",
                  zIndex: -1,
                },
              }}
            >
              <CardContent sx={{ pt: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  Create & Run Ads that Click to WhatsApp
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Making ads has never been this easy and fun! Recharge ad
                  credits, create & run ads, segregate leads, re‐engage with
                  broadcasts & drive conversions.
                </Typography>
              </CardContent>

              <Box sx={{ position: "relative", flexGrow: 1 }}>
                <Box
                  className="CardMenu"
                  sx={{
                    width: "100%",
                    borderTop: "1px solid #eee",
                    mt: 2, // reduced top margin
                    position: "relative",
                    p: isMobile ? 1 : 2, // reduced padding
                  }}
                >
                  <CardMedia
                    component="img"
                    image={img2}
                    alt="WhatsApp Ad Screenshot"
                    sx={{
                      // keep fixed tall height
                      height: isMobile ? 450 : 600,
                      objectFit: "cover",
                      // inset left/right to match Card1
                      width: isMobile
                        ? "calc(100% - 16px)"
                        : "calc(100% - 32px)",
                      mx: "auto",
                    }}
                  />

                  <StatCircle
                    label="ROAS"
                    value="7.5X"
                    top={48}
                    left={48}
                    mobile={isMobile}
                  />
                  {/* <Stat
                    label="Impressions"
                    value="22,85,134"
                    bottom={48}
                    left={48}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Spend"
                    value="₹34,346,240"
                    bottom={48}
                    right={48}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Leads"
                    value="392"
                    bottom={48}
                    rightOffset={144}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Reach"
                    value="19,50,633"
                    bottom={48}
                    rightOffset={240}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Clicks"
                    value="20,686"
                    bottom={48}
                    rightOffset={336}
                    mobile={isMobile}
                  /> */}
                  <RevenueStat
                    bottomOffset={isMobile ? 124 : 160}
                    right={48}
                    mobile={isMobile}
                  />
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Card 3 */}
          <Grid item xs={12} md={7}>
            <Card
              sx={{
                height: "100%",
                minHeight: isMobile ? 600 : 750,
                borderRadius: 3,
                border: "1px solid #e0e0e0",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                cursor: "pointer",
                bgcolor: 'rgb(230, 244, 234)',
                transition: "transform .3s, box-shadow .3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 0 16px rgba(100,200,100,0.4)",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  // background: `url(${img3}) no-repeat center/cover`,
                  opacity: 0.4,
                  borderRadius: "inherit",
                  zIndex: -1,
                },
              }}
            >
              <CardContent sx={{ pt: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  Increase your ROAS🔥
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Retarget generated leads on WhatsApp & drive 7.5x ROAS.
                </Typography>
              </CardContent>

              <Box sx={{ position: "relative", flexGrow: 1 }}>
                <Box
                  className="CardMenu"
                  sx={{
                    width: "100%",
                    borderTop: "1px solid #eee",
                    mt: 2, // reduced top margin
                    position: "relative",
                    p: isMobile ? 1 : 2, // reduced padding
                  }}
                >
                  <CardMedia
                    component="img"
                    image={img3}
                    alt="WhatsApp Ad Screenshot"
                    sx={{
                      // keep fixed tall height
                      height: isMobile ? 450 : 600,
                      objectFit: "cover",
                      // inset left/right to match Card1
                      width: isMobile
                        ? "calc(100% - 16px)"
                        : "calc(100% - 32px)",
                      mx: "auto",
                    }}
                  />

                  <StatCircle
                    label="ROAS"
                    value="7.5X"
                    top={48}
                    left={48}
                    mobile={isMobile}
                  />
                  {/* <Stat
                    label="Impressions"
                    value="22,85,134"
                    bottom={48}
                    left={48}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Spend"
                    value="₹34,346,240"
                    bottom={48}
                    right={48}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Leads"
                    value="392"
                    bottom={48}
                    rightOffset={144}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Reach"
                    value="19,50,633"
                    bottom={48}
                    rightOffset={240}
                    mobile={isMobile}
                  />
                  <Stat
                    label="Clicks"
                    value="20,686"
                    bottom={48}
                    rightOffset={336}
                    mobile={isMobile}
                  /> */}
                  <RevenueStat
                    bottomOffset={isMobile ? 124 : 160}
                    right={48}
                    mobile={isMobile}
                  />
                </Box>
              </Box>
            </Card>
          </Grid>

          {/* Card 4 */}
          <Grid item xs={12} md={5}>
            <Card
              sx={{
                height: "100%",
                minHeight: isMobile ? 550 : 650,
                borderRadius: 3,
                border: "1px solid #e0e0e0",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                overflow: "hidden",
                cursor: "pointer",
                bgcolor: 'rgb(243, 230, 255)',
                transition: "transform .3s, box-shadow .3s",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
                },
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  // background: `url(${img4}) no-repeat center/cover`,
                  opacity: 0.4,
                  borderRadius: "inherit",
                  zIndex: -1,
                },
              }}
            >
              <CardContent sx={{ pt: 4 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  View Analytics
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Monitor insightful ad analytics seamlessly within one single
                  dashboard.
                </Typography>
              </CardContent>
              <Box sx={{ position: "relative", flexGrow: 1 }}>
                <CardMedia
                  component="img"
                  image={img4}
                  alt="Dashboard Screenshot"
                  sx={{
                    width: "100%",
                    objectFit: "contain",
                    borderTop: "1px solid #eee",
                    mt: 4,
                    maxHeight: isMobile ? 350 : 450,
                  }}
                />
                {/* <Stat
                  label="Impressions"
                  value="22,85,134"
                  bottom={24}
                  left={24}
                  mobile={isMobile}
                />
                <Stat
                  label="Clicks"
                  value="20,686"
                  bottom={24}
                  right={24}
                  mobile={isMobile}
                /> */}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

// Reusable stat overlays
const Stat = ({ label, value, bottom, left, right, rightOffset, mobile }) => (
  <Box
    sx={{
      position: "absolute",
      bottom: `${mobile ? bottom - 16 : bottom}px`,
      ...(left !== undefined ? { left: `${left}px` } : {}),
      ...(rightOffset !== undefined ? { right: `${rightOffset}px` } : {}),
      ...(right !== undefined ? { right: `${right}px` } : {}),
      backgroundColor: "#e8e1fa",
      borderRadius: 1,
      p: "8px 16px",
    }}
  >
    <Typography variant="body2" sx={{ color: "#666" }}>
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Box>
);

const StatCircle = ({ label, value, top, left, mobile }) => (
  <Box
    sx={{
      position: "absolute",
      top: `${mobile ? top - 16 : top}px`,
      left: `${mobile ? left - 16 : left}px`,
      backgroundColor: "#fff",
      borderRadius: "50%",
      p: 1.5,
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
    <Typography variant="body2" sx={{ color: "#666", textAlign: "center" }}>
      {label}
    </Typography>
  </Box>
);

const RevenueStat = ({ bottomOffset, right, mobile }) => (
  <Box
    sx={{
      position: "absolute",
      bottom: `${bottomOffset}px`,
      right: `${right}px`,
      backgroundColor: "#fff",
      borderRadius: 1,
      p: "8px 16px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      ₹15.2 Cr
    </Typography>
    <Typography variant="body2" sx={{ color: "#666" }}>
      REVENUE
    </Typography>
  </Box>
);

export default Dashboard;
